import React from 'react'

const TruckCabinOptymized = props => (
  <svg
    width="217px"
    id="prefix__Layer_1"
    x={0}
    y={0}
    viewBox="0 0 236 169.7"
    xmlSpace="preserve"
    {...props}
  >
    <style>
      {
        `.prefix__st0{fill:${props.background}}.prefix__st1,.prefix__st2{fill:none}.prefix__st2{stroke:${props.border};stroke-width:2;stroke-miterlimit:10}.prefix__st3{fill:${props.color}}`
      }
    </style>
    <path
      className="prefix__st0"
      d="M178.6 158.7v10H57.4v-10M20.9 75.7v-8.8c0-4.6 3.7-8.4 8.3-8.4v64.1H25c-2.3 0-4.1-1.8-4.1-4.1V86.9M215.4 75.5v-8.7c0-4.6-3.7-8.4-8.3-8.4v64.1h4.3c2.3 0 4.1-1.8 4.1-4.1V86.9M29.3 54.4v104.3h177.5V54.4"
    />
    <path
      className="prefix__st0"
      d="M206.8 58V42.5c0-3.1-.5-6.3-1.6-9.2-2.5-6.8-7.7-12.3-14.3-15.2C171.9 9.8 165.2 1 118 1c-46.9 0-54.7 9-72.9 17.2-6.6 2.9-11.7 8.4-14.2 15.1-1.1 3-1.6 6.1-1.6 9.2v15.4M216.9 75.2h6.5c6.4 0 11.6 5.2 11.6 11.7h-21.9V79c0-2.1 1.6-3.8 3.8-3.8-.1 0 0 0 0 0z"
    />
    <path
      className="prefix__st0"
      d="M78.1 56.6l1.4-19.9c1.4-18.7 16-33.6 34.6-35.4 2.6-.3 5.2-.3 7.8 0 9.1.9 17.5 4.9 23.9 11.4 6.3 6.5 10.2 15 10.8 24l1.4 19.9"
    />
    <path className="prefix__st1" d="M184.2 60.4V15" />
    <path
      className="prefix__st0"
      d="M53.4 14.1L52 60.4M22.9 81.1h6.3v5.8h-6.3zM206.8 81.1h6.3v5.8h-6.3zM194.1 143c2.9 0 5.2-1.9 5.2-4.2M36.8 138.7c0 2.3 2.3 4.2 5.2 4.2"
    />
    <path className="prefix__st1" d="M42 143h152.1" />
    <path
      className="prefix__st0"
      d="M40.6 62.6c-2.3.5-3.9 2.2-3.9 4.1M40.6 62.6c-2.3.5-3.9 2.2-3.9 4.1M199.3 66.7c0-1.9-1.6-3.6-3.9-4.1"
    />
    <path className="prefix__st1" d="M36.8 138.7v-72M199.3 138.7v-72" />
    <path
      className="prefix__st0"
      d="M195.4 62.6c2.3.5 3.9 2.2 3.9 4.1M118 54.4c26 0 52 2.7 77.4 8.2 2.3.5 3.9 2.2 3.9 4.1v72c0 2.3-2.3 4.2-5.2 4.2H42c-2.9 0-5.2-1.9-5.2-4.2v-72c0-1.9 1.6-3.6 3.9-4.1 25.4-5.5 51.3-8.2 77.3-8.2zM22.9 86.9H1c0-6.4 5.2-11.7 11.7-11.7h6.5c2.1 0 3.7 1.7 3.7 3.7v8z"
    />
    <path
      className="prefix__st2"
      d="M178.6 158.7v10H57.4v-10M20.9 75.7v-8.8c0-4.6 3.7-8.4 8.3-8.4v64.1H25c-2.3 0-4.1-1.8-4.1-4.1V86.9M215.4 75.5v-8.7c0-4.6-3.7-8.4-8.3-8.4v64.1h4.3c2.3 0 4.1-1.8 4.1-4.1V86.9M29.3 54.4v104.3h177.5V54.4"
    />
    <path
      className="prefix__st2"
      d="M206.8 58V42.5c0-3.1-.5-6.3-1.6-9.2-2.5-6.8-7.7-12.3-14.3-15.2C171.9 9.8 165.2 1 118 1c-46.9 0-54.7 9-72.9 17.2-6.6 2.9-11.7 8.4-14.2 15.1-1.1 3-1.6 6.1-1.6 9.2v15.4M216.9 75.2h6.5c6.4 0 11.6 5.2 11.6 11.7h-21.9V79c0-2.1 1.6-3.8 3.8-3.8-.1 0 0 0 0 0z"
    />
    <path
      className="prefix__st2"
      d="M78.1 56.6l1.4-19.9c1.4-18.7 16-33.6 34.6-35.4 2.6-.3 5.2-.3 7.8 0 9.1.9 17.5 4.9 23.9 11.4 6.3 6.5 10.2 15 10.8 24l1.4 19.9M184.2 60.4V15M53.4 14.1L52 60.4M22.9 81.1h6.3v5.8h-6.3zM206.8 81.1h6.3v5.8h-6.3zM194.1 143c2.9 0 5.2-1.9 5.2-4.2M36.8 138.7c0 2.3 2.3 4.2 5.2 4.2M42 143h152.1M40.6 62.6c-2.3.5-3.9 2.2-3.9 4.1M40.6 62.6c-2.3.5-3.9 2.2-3.9 4.1M199.3 66.7c0-1.9-1.6-3.6-3.9-4.1M36.8 138.7v-72M199.3 138.7v-72M195.4 62.6c2.3.5 3.9 2.2 3.9 4.1"
    />
    <path
      className="prefix__st2"
      d="M118 54.4c26 0 52 2.7 77.4 8.2 2.3.5 3.9 2.2 3.9 4.1v72c0 2.3-2.3 4.2-5.2 4.2H42c-2.9 0-5.2-1.9-5.2-4.2v-72c0-1.9 1.6-3.6 3.9-4.1 25.4-5.5 51.3-8.2 77.3-8.2zM22.9 86.9H1c0-6.4 5.2-11.7 11.7-11.7h6.5c2.1 0 3.7 1.7 3.7 3.7v8z"
    />
    <path
      className="prefix__st3"
      d="M77.7 76.9c.4-.4 1-.6 1.7-.6s1.3.2 1.7.6c.5.4.8 1 .8 1.7s-.3 1.3-.8 1.7c-.4.4-1 .6-1.7.6-.8 0-1.4-.3-1.9-.8-.4-.4-.6-.9-.6-1.5-.1-.7.3-1.3.8-1.7zm-1.9 4.6c.9.9 2.2 1.5 3.6 1.5 1.2 0 2.4-.4 3.2-1.1 1-.8 1.6-2 1.6-3.2 0-1.3-.6-2.4-1.5-3.2-.9-.7-2-1.2-3.2-1.2-1.2 0-2.3.4-3.1 1.1-1 .8-1.6 2-1.6 3.3-.2 1 .3 2 1 2.8zm9.5 1.5v-8.8h6.8c.4 0 .7.1 1 .2.3.1.6.3.8.6.2.2.4.5.5.8.1.3.2.6.2 1 0 .3-.1.7-.2 1-.1.3-.3.6-.5.8-.2.2-.5.4-.8.6-.3.1-.6.2-1 .2h-3.4l.7-1.3c.1-.2.2-.3.2-.3.1 0 .2-.1.3-.1h1.6c.3 0 .5-.1.7-.3.2-.2.3-.4.3-.7 0-.3-.1-.5-.3-.7-.2-.2-.4-.3-.7-.3H88c-.1 0-.2 0-.3.1-.1.1-.1.2-.1.3V83h-2.3zm16.1 0h-2.2v-6.7c0-.3-.1-.5-.4-.5h-2.5l-.7-1.6h9.5l-.7 1.3c-.1.2-.2.3-.2.3H102c-.1 0-.3 0-.3.1-.1.1-.1.2-.1.3V83zm10.2-4.2V83h-2.2v-4.3l-3.6-4.4h2.3l2.4 3.1 2.4-3.1h2.3l-3.6 4.5zm15.6-4.1v8.2H125v-7l-2.3 7h-1.9l-2.5-7v7h-2.2v-8.3c0-.1 0-.3.1-.3.1-.1.2-.1.3-.1h3l2.1 5.4c.1-.4 1.5-4.3 1.9-5.4h3.1c.2 0 .3 0 .4.2.2.1.2.3.2.3zm3.3-.5V83h-2.2v-8.8h2.2zm11.8 8.8l-.8-1.6c-.1-.2-.2-.3-.3-.3-.1-.1-.2-.1-.4-.1h-5.1l6-4.2v-2.5h-9.6l.8 1.6c.1.2.2.3.3.4.1 0 .2.1.4.1h5.3l-6.8 4.7v2l10.2-.1zm7.6-1.9c-.1 0-.2-.1-.4-.1h-3.2c-.8 0-.8-.4-.8-.6v-1h3.2v-1.5h-3.2v-1.2c0-.2.1-.4.7-.4h3.3c.2 0 .3-.1.4-.1 0 0 .1-.1.1-.2.1-.1.1-.2.1-.2l.6-1.5H144c-.4 0-.7.3-.7.7v7.6c0 .2.2.4.4.4h6.9l-.6-1.6c0-.1-.1-.2-.1-.3zM157 83h-2.5l.7-1.3c.1-.2.2-.3.3-.3.1 0 .2-.1.3-.1h1.6c.8 0 2-.7 1.9-2.8 0-.6-.3-1.2-.6-1.6-.5-.5-1.1-.7-2-.7h-1.9c-.8 0-.8.2-.8.6V83h-2.2v-8c0-.4.3-.8.7-.8h4.4c1.4 0 2.5.6 3.3 1.5.7.8 1.1 1.8 1.1 2.8.2 1.4-.6 4.5-4.3 4.5z"
    />
    <text
      transform="translate(56.013 104.058)"
      fontSize={20}
      fontFamily="OpenSans-Bold"
      fill="#05a792"
      fontWeight="bold"
    >
      {`Route: ${props.route}`}
    </text>
    <text
      transform="translate(79.743 122.953)"
      className="prefix__st3"
      fontSize={10}
      fontFamily="OpenSans-Regular"
      fontWeight="bold"
    >
      {`Start time: ${props.time}`}
    </text>
  </svg>
)

export default TruckCabinOptymized;
